import { View } from 'react-native';
import { Icon } from '@/components/Icon';
import theme from '@/config/theme';
import { styles } from './styles';

type FeedBackProps = {
  status: 'correct' | 'wrong';
};

export const FeedBack = ({ status }: FeedBackProps) => {
  const isCorrect = status === 'correct';
  const iconName = isCorrect ? 'like' : 'dislike';

  return (
    <View
      style={[styles.container, isCorrect ? styles.correctBg : styles.wrongBg]}
    >
      <Icon name={iconName} color={theme.colors.lightBlue} size={40} />
    </View>
  );
};
